export { default } from './GroupRegistrationDetailPage';
